interface TagsBlockProps {
  show: boolean;
  tagList: string[] | null | undefined;
}

export function TagsBlock({ show, tagList }: TagsBlockProps) {
  if (!show) return null;
  return (
    <div className="min-h-[24px] max-h-[54px] mt-3 flex overflow-hidden flex-wrap gap-2 content-start">
      {tagList?.map((tag, i) => (
        <span
          key={i}
          className="text-xs text-[#262626] bg-[#F5F5F5] rounded-[28px] px-2 py-0.5 leading-[18px] max-w-full truncate"
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
